import { render, staticRenderFns } from "./bossWorkBench.vue?vue&type=template&id=5dedd0de&"
import script from "./bossWorkBench.vue?vue&type=script&lang=js&"
export * from "./bossWorkBench.vue?vue&type=script&lang=js&"
import style0 from "./bossWorkBench.vue?vue&type=style&index=0&id=5dedd0de&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports